<template>
    <div class="spare-part-kit-item">
        <div class="spare-part-kit-item__inner">
            <h3 class="spare-part-kit-item__number">{{ sparePartKit.ItemNumber }}</h3>
            <p class="spare-part-kit-item__description">{{ sparePartKit.Description }}</p>
            <p class="spare-part-kit-item__description">{{ sparePartKit.ExtendedDescription }}</p>
            <a v-if="sparePartKit.HasPdfUrl" :href="sparePartKit.PdfUrl" target="_blank"
                class="spare-part-kit-item__link">{{ buttonText }}</a>
        </div>
    </div>
</template>

<script>
export default {
    name: "sparePartKitItem",
    props: ["sparePartKit", "buttonText"]
};
</script>